import { useEffect, useState, Fragment } from 'react';
import {
    Radio,
    Label,
    Input,
    FormGroup,
    Card,
    CheckboxList,
    Checkbox,
    SelectGroup,
    FieldMessage,
    Divider,
} from '@ruter-ds/rds-components/dist/cjs';
import { OptionImage } from './OptionImage';
import { QuestionDescription } from './QuestionDescription';

export const QuestionView = ({ question, onChange, currentValue, displayError, setDisplayError }) => {
    const [value, setValue] = useState();

    const handleChange = (value) => {
        onChange(question.id, value);
        setValue(value);
    };
    const toggleEntryInList = (list, value) => {
        const idx = list.findIndex((val) => val === value);
        if (idx >= 0) {
            list.splice(idx, 1);
        } else {
            list.push(value);
        }
        const newValue = [...list];
        onChange(question.id, newValue);
        setValue(newValue);
    };

    useEffect(() => {
        if (currentValue) {
            setValue(currentValue);
        } else {
            setValue(question.answerMode === 'checkbox' ? [] : '');
        }
    }, [question, currentValue]);

    const showError = displayError ? true : false;

    const renderQuestion = () => {
        switch (question.answerMode) {
            case 'dropdown':
                return (
                    <Fragment>
                        <legend className="rds-legend rds-legend--render-as-label">{question.name}</legend>
                        <QuestionDescription question={question} />
                        <SelectGroup
                            label={question.name}
                            value={value}
                            hideLabel={true}
                            onChange={(e) => handleChange(e.target.value, true)}
                            fieldMessage={question.required && displayError ? 'Du må velge et alternativ' : ''}
                            hasError={question.required && showError}
                        >
                            <option value="" disabled>
                                Velg noe fra lista
                            </option>
                            {question.answerOptions
                                .sort((a, b) => (a.order > b.order ? 1 : -1))
                                .map((option) => (
                                    <option key={option.id} value={option.value}>
                                        {option.value}
                                    </option>
                                ))}
                        </SelectGroup>
                    </Fragment>
                );
            case 'checkbox':
                return (
                    <Fragment>
                        <legend className="rds-legend rds-legend--render-as-label">{question.name}</legend>
                        <QuestionDescription question={question} />
                        <CheckboxList
                            groupTitle={question.name}
                            fieldMessage={question.required && displayError && 'Du må velge minst ett alternativ'}
                            hasError={question.required && displayError}
                            hideGroupTitle
                        >
                            {question.answerOptions
                                .sort((a, b) => (a.order > b.order ? 1 : -1))
                                .map((option, i) => (
                                    <div key={option.id}>
                                        <Checkbox
                                            value={option.value}
                                            label={option.value}
                                            checked={value ? value.includes(option.value) : false}
                                            onChange={(e) => toggleEntryInList(value, e.target.value)}
                                        />
                                        <OptionImage option={option} />
                                        {i < question.answerOptions.length - 1 && option.picture && <Divider spacing="s" />}
                                    </div>
                                ))}
                        </CheckboxList>
                    </Fragment>
                );
            case 'radio':
                return (
                    <fieldset className="rds-fieldset rds-radio-list-item">
                        <legend className="rds-legend rds-legend--render-as-label">{question.name}</legend>
                        <QuestionDescription question={question} />

                        {question.answerOptions
                            .filter((option) => option)
                            .sort((a, b) => (a.order > b.order ? 1 : -1))
                            .map((option, i) => (
                                <div key={option.id} className="rds-radio-list__item">
                                    <Radio
                                        name={'attributeId_' + question.id}
                                        label={option.value}
                                        value={option.value}
                                        selectedValue={value}
                                        onChange={(e) => handleChange(e.target.value, true)}
                                    />
                                    <OptionImage option={option} />
                                    {i < question.answerOptions.length - 1 && option.picture && <Divider spacing="s" />}
                                </div>
                            ))}
                        {question.required && showError && <FieldMessage skin="danger" text="Du må velge et alternativ" />}
                    </fieldset>
                );
            default:
                return (
                    <>
                        <Label labelText={question.name} htmlFor={'input_' + question.id} />
                        <QuestionDescription question={question} />
                        <div>
                            <Input
                                required={question.required}
                                type="text"
                                id={'input_' + question.id}
                                value={value}
                                onChange={(e) => handleChange(e.target.value, true)}
                                aria-describedby={'fieldMessageId_' + question.id}
                                hasError={question.required && showError}
                            />
                            {displayError && <FieldMessage skin="danger" text={displayError} />}
                        </div>
                    </>
                );
        }
    };

    return (
        <Card className="rds-my--m rds-mr--xs rs-charlie rs-flex-grow questionCard">
            <FormGroup className="rds-p--s formGroup">{renderQuestion()}</FormGroup>
        </Card>
    );
};
